import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-button',

    mixins: [
        AppComponent
    ],

    props: {
        to: { type: String, default: '#' }
    },

    data() {
        return {
            step: 0,
            isHover: false
        }
    },

    watch: {
        step: 'onStepChange'
    },

    created() {
        this.timeDurationLeftAndRight = 250
        this.timeDurationTopAndBottom = 350
    },

    methods:
    {
        onStepChange() {
            
        },

        _onClick() {
            if (this.to !== '#') {
                if (!this.$el.getAttribute('disabled')) {
                    this.$root.changePage(this.to)
                } else {
                    this.eventHub.$emit('app-button:disabled')
                }
            }
        },

        _onMouseenter() {
            this.isHover = true

            if (this.step === 0) {
                this.step = 1

                if (this.isHover) {
                    setTimeout(() => {
                        if (this.isHover) {
                            this.step = 2

                            setTimeout(() => {
                                if (this.isHover) {
                                    this.step = 3

                                    setTimeout(() => {
                                        this.step = 4
                                    }, this.timeDurationLeftAndRight)
                                }
                            }, this.timeDurationTopAndBottom)
                        }
                    }, this.timeDurationLeftAndRight)
                }
            } else if (this.step === 1) {
                this.step = 1

                if (this.isHover) {
                    setTimeout(() => {
                        if (this.isHover) {
                            this.step = 2

                            setTimeout(() => {
                                if (this.isHover) {
                                    this.step = 3

                                    setTimeout(() => {
                                        this.step = 4
                                    }, this.timeDurationLeftAndRight)
                                }
                            }, this.timeDurationTopAndBottom)
                        }
                    }, this.timeDurationLeftAndRight)
                }
            } else if (this.step === 2) {
                this.step = 2

                setTimeout(() => {
                    if (this.isHover) {
                        this.step = 3

                        setTimeout(() => {
                            this.step = 4
                        }, this.timeDurationLeftAndRight)
                    }
                }, this.timeDurationTopAndBottom)
            } else if (this.step === 3) {
                this.step = 3

                setTimeout(() => {
                    this.step = 4
                }, this.timeDurationLeftAndRight)
            }
        },

        _onMouseleave() {
            this.isHover = false

            if (this.step === 4 || this.step === 3) {
                this.step = 3

                if (!this.isHover) {
                    setTimeout(() => {
                        if (!this.isHover) {
                            this.step = 2

                            setTimeout(() => {
                                if (!this.isHover) {
                                    this.step = 1

                                    setTimeout(() => {
                                        this.step = 0
                                    }, this.timeDurationLeftAndRight)
                                }
                            }, this.timeDurationTopAndBottom)
                        }
                    }, this.timeDurationLeftAndRight)
                }
            } else if (this.step === 3) {
                this.step = 3

                if (!this.isHover) {
                    setTimeout(() => {
                        if (!this.isHover) {
                            this.step = 2

                            setTimeout(() => {
                                if (!this.isHover) {
                                    this.step = 1

                                    setTimeout(() => {
                                        this.step = 0
                                    }, this.timeDurationLeftAndRight)
                                }
                            }, this.timeDurationTopAndBottom)
                        }
                    }, this.timeDurationLeftAndRight)
                }
            } else if (this.step === 2) {
                this.step = 2

                setTimeout(() => {
                    if (!this.isHover) {
                        this.step = 1

                        setTimeout(() => {
                            this.step = 0
                        }, this.timeDurationLeftAndRight)
                    }
                }, this.timeDurationTopAndBottom)
            } else if (this.step === 1) {
                this.step = 1

                setTimeout(() => {
                    this.step = 0
                }, this.timeDurationLeftAndRight)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-button/script.js